export default __webpack_public_path__ + "static/QuickBrush-Web-0700a0ac62ee9e356832304b898c9892.woff2";